const B = process.env.REACT_APP_BACKEND_URL;
const ver = () => localStorage.getItem("site_logo_v") || "1";

export const siteLogoUrl = () => `${B}/api/site-logo?v=${ver()}`;

// Logo from Settings > Pages > Logo, falling back to the copy bundled with the site
export const SiteLogo = ({ className = "", style, testId }) => (
  <img src={siteLogoUrl()} alt="Prime Media Wireless" className={className} style={style} data-testid={testId}
    onError={(e) => { if (!e.currentTarget.src.endsWith("/pmw-logo.png")) e.currentTarget.src = "/pmw-logo.png"; }} />
);
